import fetch from "auth/FetchInterceptor"

const AuthService = {}

AuthService.login = function (data) {
  return fetch({
    url: "/partner/login",
    method: "post",
    data: data,
  })
}

AuthService.register = function (data) {
  return fetch({
    url: "/partner/signup",
    method: "post",
    data: data,
  })
}
AuthService.getProfile = function () {
  return fetch({
    url: "/partner/getMyProfile",
    method: "get",
  })
}

AuthService.updateProfile = function (data) {
  return fetch({
    url: "/partner/editMyProfile",
    method: "put",
    data,
  })
}

AuthService.updateRecomponse = function (data) {
  return fetch({
    url: "/partner/updateRecompenseResponse",
    method: "put",
    data,
  })
}

AuthService.forgotPassword = function (email) {
  return fetch({
    url: "/partner/forgot-password",
    method: "post",
    data: { email },
  })
}

AuthService.resetPassword = function (data) {
  return fetch({
    url: "/partner/reset-password",
    method: "post",
    data,
  })
}

export default AuthService
